import moment from "moment-timezone";
import { cc, Formats, RestaurantUtils } from "..";
export function menuRestrictionsEnabled({ item }) {
    const times = item.restrict_times || [];
    const services = item.restrict_services || [];
    const hours = item.restrict_hours || [];
    if (item.restrict_age)
        return true;
    if (times.length > 0)
        return true;
    if (services.length > 0)
        return true;
    if (hours.length > 0)
        return true;
    if (item.restrict_pre_order)
        return true;
    return false;
}
export function menuRestrictedForOrder(opts) {
    const { item, orderDue, orderService, orderDueTimestamp, customerAgeVerified, customerAgeVerifiedPrompt, requireId, } = opts;
    if (item.restrict_age && !customerAgeVerified) {
        if (requireId && !customerAgeVerified) {
            return {
                isRestricted: true,
                reason: "age",
            };
        }
        else if (!requireId && !customerAgeVerifiedPrompt) {
            return {
                isRestricted: true,
                reason: "age",
            };
        }
    }
    const times = item.restrict_times || [];
    const services = item.restrict_services || [];
    const hours = item.restrict_hours || [];
    if (times.length > 0 && (orderDue === "" || times.indexOf(orderDue) === -1)) {
        return {
            isRestricted: true,
            reason: "times",
        };
    }
    if (services.length > 0 && (orderService === "" || services.indexOf(orderService) === -1)) {
        return {
            isRestricted: true,
            reason: "services",
        };
    }
    if (hours.length > 0) {
        const due = moment.tz(orderDueTimestamp, cc.timezone);
        const { isWithin } = RestaurantUtils.opening_hours.isTimeWithin({
            dt: due.clone(),
            timezone: cc.timezone,
            hours: hours,
            last_offset: 0,
            first_offset: 0,
        });
        if (!isWithin) {
            return {
                isRestricted: true,
                reason: "hours",
            };
        }
    }
    if (item.restrict_pre_order && item.restrict_pre_order_cutoff) {
        const restrict_pre_order_services = item.restrict_pre_order_services || [];
        if (restrict_pre_order_services.length === 0 ||
            restrict_pre_order_services.indexOf(orderService) !== -1) {
            if (orderDue !== "later") {
                return {
                    isRestricted: true,
                    reason: "pre_order",
                };
            }
            const cutoff_time = item.restrict_pre_order_cutoff;
            const days_in_advance = item.restrict_pre_order_days_advance || 0;
            const now = moment.tz(cc.timezone);
            const due = moment.tz(orderDueTimestamp, cc.timezone);
            const cutoff_date = due.clone().subtract(days_in_advance, "days").format(Formats.moment.date);
            const cutoff = moment.tz(`${cutoff_date} ${cutoff_time}`, Formats.moment.datetime, cc.timezone);
            if (now.isAfter(cutoff)) {
                return {
                    isRestricted: true,
                    reason: "pre_order",
                };
            }
        }
    }
    return {
        isRestricted: false,
        reason: "",
    };
}
export function serviceGetStatusReadyTime(args) {
    const { isWithin, index } = RestaurantUtils.opening_hours.isTimeWithin({
        dt: moment.tz(args.timestamp, cc.timezone),
        timezone: cc.timezone,
        hours: args.auto_status_time_ready_periods,
        last_offset: 0,
        first_offset: 0,
    });
    if (isWithin && index !== -1) {
        return args.auto_status_time_ready_periods[index].time_ready;
    }
    return args.auto_status_time_ready;
}
//# sourceMappingURL=utils.js.map